import React from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'react-bootstrap';
import { Typography } from '@ajaibid/components';
import styles from '../style';

const ON_PROCESS = require('Icon/icon_on_process.png');
const SUCCESS = require('Icon/icon_success_check.png');
const FAILED = require('Icon/icon_failed_cross.png');

const iconData = {
  deposit: {
    WAITING_PAYMENT: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Transaksi dibuat pada ',
      stat: 'Menunggu Setoran',
    },
    PROOF_UPLOADED: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Bukti transfer diterima tanggal ',
      stat: 'Bukti Setoran Terunggah',
    },
    PAYMENT_ACCEPTED: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Diverifikasi oleh Manajer Investasi ',
      stat: 'Setoran Diterima',
    },
    IN_PROGRESS: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Transaksi diproses sejak ',
      stat: 'Unit Reksa Dana Diproses',
    },
    CONFIRMED: {
      iconsAwesome: <img src={ON_PROCESS} alt="" style={styles.imgStepper} />,
      info: 'Transaksi selesai pada ',
      stat: 'Unit Diterima',
    },
    CANCELED: {
      iconsAwesome: <img src={FAILED} alt="" style={styles.imgStepper} />,
      info: 'Dibatalkan pada ',
      extinfo: (cancellationStatus) =>
        ` ${cancellationStatus?.reason ? cancellationStatus.reason : ''}`,
      stat: 'Setoran Dibatalkan',
    },
    FINAL_CHECKING: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Melakukan pengecekan ulang di ',
      stat: 'Pemeriksaan Terakhir',
    },
  },
  withdraw: {
    IN_PROGRESS: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Dicairkan bertahap sejak ',
      stat: 'Permintaan Diproses Bank Kustodian',
    },
    CONFIRMED: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: ', WIB, belum termasuk biaya transfer antarbank',
      info: 'Proses transfer berlangsung maks. 7 hari kerja sejak ',
      stat: 'Permintaan Penarikan Berhasil',
    },
    RECEIVED: {
      iconsAwesome: <img src={SUCCESS} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: '',
      stat: 'Permintaan Penarikan Diterima',
    },
    CANCELED: {
      iconsAwesome: <img src={FAILED} alt="" style={styles.imgStepper} />,
      extinfo: '',
      info: 'Dibatalkan pada',
      stat: 'Dibatalkan',
    },
  },
};

const StepperIcon = (props) => {
  const { type, title, typeTrans, length, index, cancellationStatus } = props;
  const { iconsAwesome, extinfo, info, stat } = iconData[typeTrans]?.[type] || {};

  return (
    <Row noGutters>
      <Col md={1} lg={1} className="pl-0">
        <div>
          {index === length - 1 && type !== 'CANCELED' ? (
            <img src={ON_PROCESS} alt="" />
          ) : (
            iconsAwesome
          )}
        </div>
      </Col>
      <Col md={10} lg={10} className="pr-0">
        <Typography type="section" style={{ marginTop: -2 }}>
          {stat}
        </Typography>
        <Typography color="grey" size="label" style={{ marginTop: -8 }}>
          {info}
          {title}
          {typeof extinfo === 'function' ? extinfo(cancellationStatus) : extinfo}
        </Typography>
        <br />
      </Col>
    </Row>
  );
};

StepperIcon.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  typeTrans: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  length: PropTypes.number.isRequired,
  cancellationStatus: PropTypes.shape({
    reason: PropTypes.string,
    source: PropTypes.string,
  }),
};

StepperIcon.defaultProps = {
  cancellationStatus: null,
};

export default StepperIcon;
